import type { ReactElement } from "react";

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  Rect,
} from "@/crossPlatform/react-native-svg";

const LightBulbIllustrationSVG = ({
  height,
  width,
}: Partial<SizeDimensions>): ReactElement<Partial<SizeDimensions>, "svg"> => (
  <Svg fill="none" height={height} viewBox="0 0 240 240" width={width}>
    <G clipPath="url(#clip0_5102_19489)">
      <Path
        d="M90.0588 197.74C133.16 203.764 172.804 172.379 178.608 127.641C184.411 82.9021 154.175 41.7511 111.074 35.7273C67.9734 29.7035 28.3287 61.0881 22.5255 105.827C16.7222 150.565 46.9579 191.716 90.0588 197.74Z"
        fill="#DCE7FF"
      />
      <Path
        d="M158.394 179.386C167.881 175.479 176.316 168.786 181.836 159.781C188.506 148.905 190.885 135.663 190.526 122.909C190.167 110.084 187.22 96.783 180.971 85.6357C175.478 75.8359 167.553 67.8813 158.264 61.9721C146.418 54.4396 132.911 50.5759 119.649 46.7339C116.384 45.7869 115.322 59.9375 119.993 61.2903C139.576 66.9668 160.445 73.6714 173.494 91.0037C184.731 105.923 188.719 129.045 179.295 145.858C174.14 155.052 165.861 161.508 156.436 165.393C152.687 166.935 153.864 181.253 158.394 179.386Z"
        fill="#164356"
      />
      <Path
        d="M134.416 51.5826C119.722 47.075 103.856 50.0566 91.5572 59.6237C79.2584 69.1909 71.1355 85.23 68.5112 101.247C67.0168 110.398 66.819 119.862 68.4644 129.013C69.6516 135.62 71.5 142.189 75.249 147.73C81.2474 156.594 88.6882 164.516 95.6759 172.53C104.007 182.087 112.734 191.443 120.294 201.687C122.211 204.284 124.002 200.794 124.413 198.97C125.1 195.951 124.991 191.627 123.08 189.04C110.526 172.033 95.327 157.265 82.2316 140.717C81.0131 139.181 79.8155 137.622 78.6804 136.02C78.2326 135.382 77.8004 134.733 77.3683 134.083C76.5508 132.849 77.5661 134.7 76.9465 133.363C75.5771 130.414 74.6138 127.265 74.0931 124.029C73.5724 120.793 73.3225 117.243 73.4266 114.462C73.9213 100.82 79.6541 86.6694 89.3911 77.2051C100.925 65.9874 117.774 60.9549 133.119 65.6628C135.816 66.4907 136.566 62.5458 136.759 60.4841C136.936 58.6064 136.946 52.3618 134.41 51.588L134.416 51.5826Z"
        fill="#164356"
      />
      <Path
        d="M111.88 189.175C113.796 198.845 115.702 208.52 117.633 218.19C119.565 227.866 125.892 235.62 135.868 236.27C138.857 236.464 141.903 235.896 144.881 235.658C147.605 235.442 150.151 235.128 152.723 234.121C157.17 232.379 160.685 228.856 162.773 224.451C165.829 218.012 165.553 210.485 163.694 203.731C162.7 200.106 161.158 196.935 159.388 193.672C159.258 193.428 157.29 190.144 157.628 189.857C158.06 189.489 157.623 192.93 157.649 192.958C157.685 192.985 158.112 192.406 158.461 192.103C160.752 190.095 160.789 185.923 160.383 183.098C160.211 181.908 158.742 176.15 156.503 178.109C151.447 182.535 150.942 190.333 152.374 196.643C153.614 202.097 157.326 206.329 158.716 211.681C158.945 212.557 159.128 213.91 159.018 212.081C159.034 212.335 158.753 213.277 158.992 212.325C158.966 212.417 158.607 213.299 158.873 212.752C158.008 214.527 157.087 216.048 155.561 217.325C151.661 220.593 147.339 220.853 142.533 221.275C137.441 221.724 132.781 222.222 128.219 219.332C126.657 218.342 125.262 217.103 124.252 215.506C123.981 215.084 123.46 214.007 123.465 214.024C122.559 212.233 123.569 214.776 123.434 214.181C122.361 209.505 121.565 204.743 120.627 200.036C119.643 195.079 118.659 190.122 117.68 185.165C117.331 183.412 116.425 178.856 113.801 180.176C111.448 181.361 111.474 187.14 111.88 189.18V189.175Z"
        fill="#164356"
      />
      <Path
        d="M122.627 215.707C135.171 215.891 147.714 215.572 160.237 214.744C163.518 214.527 163.148 203.618 159.977 203.829C147.454 204.657 134.916 204.976 122.367 204.792C119.222 204.744 119.305 215.658 122.627 215.707Z"
        fill="#164356"
      />
      <Path
        d="M119.289 202.638H133.942C138.17 202.638 137.987 188.082 133.598 188.082H118.946C114.718 188.082 114.9 202.638 119.289 202.638Z"
        fill="#164356"
      />
      <Path
        d="M40.0708 50.3652C46.9388 57.0103 53.8016 63.6554 60.6696 70.3005C62.8461 72.4054 64.278 69.8351 64.7883 67.584C65.3714 65.019 65.5901 59.7214 63.4553 57.6543C56.5873 51.0092 49.7245 44.3641 42.8566 37.719C40.6801 35.6141 39.2481 38.1844 38.7379 40.4355C38.1547 43.0005 37.936 48.2981 40.0708 50.3652Z"
        fill="#164356"
      />
      <Path
        d="M109.855 12.9245C110.646 19.9267 111.438 26.9343 112.229 33.9365C112.432 35.7385 113.573 40.1974 116.108 38.9258C118.644 37.6541 118.275 32.0372 118.03 29.9214C117.238 22.9191 116.447 15.9115 115.655 8.9093C115.452 7.10734 114.312 2.64843 111.776 3.92009C109.24 5.19174 109.61 10.8087 109.855 12.9245Z"
        fill="#164356"
      />
      <Path
        d="M126.929 165.361C128.039 175.324 129.15 185.295 130.261 195.258C130.546 197.821 132.146 204.166 135.704 202.356C139.263 200.547 138.744 192.555 138.401 189.545C137.29 179.582 136.179 169.611 135.069 159.648C134.784 157.084 133.183 150.74 129.625 152.549C126.066 154.359 126.585 162.351 126.929 165.361Z"
        fill="#164356"
      />
      <Path
        d="M183.757 20.1483C178.539 28.5087 173.962 37.2967 170.062 46.4039C168.781 49.3963 168.938 53.7632 170.307 56.6962C171.525 59.3044 173.504 59.2178 174.629 56.5879C178.196 48.2599 182.366 40.2891 187.141 32.6375C188.88 29.8561 188.865 25.749 188 22.6537C187.516 20.9221 185.522 17.3236 183.757 20.1483Z"
        fill="#164356"
      />
      <Path
        d="M15.3793 131.837C26.944 132.697 38.4878 131.301 49.5526 127.703C54.1243 126.215 52.5466 112.059 49.2089 113.146C38.1441 116.745 26.6003 118.141 15.0357 117.281C11.0107 116.983 10.8441 131.496 15.3793 131.837Z"
        fill="#164356"
      />
      <Path
        d="M200.612 98.9526C208.833 97.681 216.993 96.0251 225.069 93.9905C229.64 92.8379 228.344 78.525 224.725 79.4341C216.644 81.4687 208.49 83.1246 200.268 84.3962C195.764 85.0943 196.654 99.5641 200.612 98.9526Z"
        fill="#164356"
      />
    </G>
    <Defs>
      <ClipPath id="clip0_5102_19489">
        <Rect
          fill="white"
          height="232.615"
          transform="translate(12 3.69238)"
          width="216"
        />
      </ClipPath>
    </Defs>
  </Svg>
);

export default LightBulbIllustrationSVG;
